/**
 * `?alert=<id>` of `/admin/health` — the link in the operator Telegram (#1352).
 *
 * Its own module, not a part of the page: the route file (`health.tsx`) needs
 * the validator, and importing it from the page's lazy chunk would pull the
 * whole page into the route's eager bundle.
 */

/** The largest id that survives a round trip through a JS number. */
const MAX_ALERT_ID = 999_999_999_999_999;

/**
 * A positive integer id, or `undefined`.
 *
 * TanStack Router JSON-parses search values, so `?alert=42` arrives as the
 * number `42` and `?alert=abc` as the string `'abc'`. Everything that is not a
 * plain positive integer — a float, a negative, a string, an SQL-looking
 * value — is dropped here and never reaches a request.
 */
export function parseAlertSearch(raw: unknown): number | undefined {
  const n = typeof raw === 'string' && /^\d+$/.test(raw) ? Number(raw) : raw;
  return typeof n === 'number' && Number.isInteger(n) && n > 0 && n <= MAX_ALERT_ID
    ? n
    : undefined;
}
